import type { OrganizationsListTableRowActionsProps } from "@/modules/organizations/organizations-list-table/organizations-list-table-row-actions/organizations-list-table-row-actions.type";

import ListTableRowActions from "@/modules/list-table-row-actions";

import { OrganizationsListTableRowActions } from "./organizations-list-table-row-actions.component";

export const OrganizationsListTableRowActionsWrapper = (
  props: OrganizationsListTableRowActionsProps
) => {
  return (
    <ListTableRowActions
      modelKey="organization"
      modelId={props.organization.id}
    >
      <OrganizationsListTableRowActions {...props} />
    </ListTableRowActions>
  );
};
